import { Popover, MenuList } from '@material-ui/core'
import React, { useState } from 'react'
import Input from '@material-ui/core/Input'
import { injectIntl } from 'react-intl'
import MenuItem from 'components/override/MaterialUI/MenuItemRadio'
import translate from './translate'

function RadioSelect({
  options = {},
  selected = [],
  setSelected,
  buttonRef,
  handleClose,
  allSelectedSites,
  isMultiple,
  disabled,
  intl: { formatMessage },
}) {
  const [searchValue, setSearchValue] = useState('')
  const getFilteredList = list =>
    (list || []).filter(
      option =>
        option &&
        option.name &&
        option.name.toUpperCase().includes(searchValue.toUpperCase()) &&
        !allSelectedSites.includes(option.id),
    )
  const allOptions = getFilteredList(options)

  const isSelected = id =>
    !!selected.find(selectedItem => selectedItem && selectedItem.id === id)

  return (
    <Popover
      open={!!buttonRef && !disabled}
      anchorEl={buttonRef}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}>
      <div className="multi-select">
        <div className="search-block">
          <Input
            className="search-field"
            placeholder={formatMessage(translate.searchBySite)}
            onChange={({ target: { value } }) => setSearchValue(value)}
            value={searchValue}
            disableUnderline
          />
        </div>
        <MenuList className="option-list">
          {(allOptions || []).map(({ name, id }) => (
            <MenuItem
              key={`${id}${name}`}
              value={id}
              selected={isSelected(id)}
              isPurpleStyle
              onClick={() => {
                if (isMultiple) {
                  if (isSelected(id)) {
                    setSelected(
                      selected.filter(
                        selectedItem => selectedItem && selectedItem.id !== id,
                      ),
                    )

                    return
                  }

                  setSelected([...selected, { id, name }])
                } else {
                  setSelected([{ id, name }])
                }
              }}>
              {name}
            </MenuItem>
          ))}
        </MenuList>
      </div>
    </Popover>
  )
}

export default injectIntl(RadioSelect)
